export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9639.9fb0f27e.jpg";